import parseUrl from 'hooks/useNavigationCallback/parseUrl';
import { useCallback, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const encodeCallback = (c) => encodeURIComponent(c);
const decodeCallback = (c) => (c ? decodeURIComponent(c) : c);

const CALLBACK_KEY = 'callback';

const useNavigationCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const search = location.search;
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const callbackParam = useMemo(
    () => decodeCallback(searchParams.get(CALLBACK_KEY)),
    [searchParams]
  );

  const navigateToWithCallback = useCallback(
    (where, callback) => {
      const whereLocation = parseUrl(where);
      const whereSearchParams = new URLSearchParams(whereLocation.search);
      whereSearchParams.set(CALLBACK_KEY, encodeCallback(callback));
      const newWhere = `${
        whereLocation.pathname
      }?${whereSearchParams.toString()}`;

      navigate(newWhere);
    },
    [navigate]
  );

  const navigateToAndBackHere = useCallback(
    (where) => {
      navigateToWithCallback(where, `${location.pathname}${location.search}`);
    },
    [navigateToWithCallback, location.pathname, location.search]
  );

  const gotToCallback = useCallback(
    (replace) =>
      callbackParam
        ? navigate(callbackParam, replace ? { replace: true } : undefined)
        : null,
    [callbackParam, navigate]
  );

  return {
    navigateToAndBackHere,
    navigateToWithCallback,
    gotToCallback,
    callbackParam,
  };
};

export default useNavigationCallback;
